export default __webpack_public_path__ + "static/media/bmp.9d177b74.svg";